export default __webpack_public_path__ + "static/mobile-nav-ffbc-52e110fcb4974f398c74998f5abbd5d9.webp";